
import { TileType } from './types.js';

export const GRID_SIZE = 7;
export const INITIAL_TARGET_SCORE = 500;
export const DIFFICULTY_MULTIPLIER = 1.1;
export const INITIAL_TIME = 60; // 30 seconds per level
export const TIME_BONUS_DEA_PER_LEVEL = 10;
export const MIN_INITIAL_TIME = 10; //min time
export const TIME_BONUS_PER_TILE = 1; // 1 second back per tile matched
export const ADV_PLAY_TIME = 30;// adv play time when continue play
export const ADV_ROUND = 3;// adv round per continue play

export const TILE_TYPES = ['1', '2', '3', '4', '5', '6', '7'];

export const SOUND_FREQUENCIES = {
  SELECT: 440,
  MATCH: 880,
  FAIL: 220,
  LEVEL_UP: 1200
};
